import React, { useState, useEffect } from "react";
import { Container, Button, Form, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FaEye, FaEdit, FaTrashAlt } from "react-icons/fa";
import { simplePostCall } from "../../api/ApiServices"; // Assuming this exists based on your snippet
import ApiConfig from "../../api/ApiConfig";
import "../../Styles/yellocalfcss/ViewInvoice.css";
import ScaleLoader from "react-spinners/ScaleLoader";

const ViewInvoice = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [invoices, setInvoices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [generateInvoice, setGenerateInvoice] = useState(false);
  const [message, setMessage] = useState("");
  const [filters, setFilters] = useState({
    student: "",
    academicYear: "",
  });

  // Helper: Format Date from API (2024-06-09T...) to readable string
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const loadInvoices = async () => {
    setIsLoading(true);
    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      invoice_id: Number(id), // or whatever key your API expects for the bill ID

      // Add other filter params if required by your API
    };

    try {
      const response = await simplePostCall(
        ApiConfig.feeinvoiceView, // Update this endpoint as per your routing
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        // Map student names from studentModel for easy lookup
        const studentMap = {};
        response.studentModel?.forEach((s) => {
          studentMap[s.student_id] = s.student_name;
        });

        // Transform API invoiceModel to match UI structure
        const formattedInvoices = response.invoiceModel.map((inv) => ({
          id: inv.fee_invoice_id,
          invoiceId: `INV-${inv.fee_invoice_id}`, // UI Display ID
          student: studentMap[inv.fee_invoice_student] || "Unknown Student",
          academicYear: inv.academic_year_name || "N/A",
          demandDate: formatDate(inv.fee_invoice_demand_date),
          dueDate: formatDate(inv.fee_invoice_due_date),
          amountTotal: parseFloat(inv.fee_invoice_amount_total),
          amountPaid: parseFloat(inv.fee_invoice_total_amount_paid),
          balance:
            parseFloat(inv.fee_invoice_amount_total) -
            parseFloat(inv.fee_invoice_total_amount_paid),
          status: inv.fee_invoice_status,
        }));

        setInvoices(formattedInvoices);
      }
    } catch (error) {
      console.error("Error loading invoices:", error);
      setMessage("Failed to load data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadInvoices();
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleClear = () => {
    setFilters({ student: "", academicYear: "" });
    loadInvoices(); // Refresh data
  };

  const handleGenerateInvoiceToggle = () =>
    setGenerateInvoice(!generateInvoice);

  return (
    <div className="upcoming-invoices-primary-wrapper">
      <Container fluid className="upcoming-invoices-container-wrapper">
        <div className="upcoming-invoices-header-section">
          <h1 className="upcoming-invoices-title-label">
            Upcoming Fee Invoices
          </h1>
          <div className="upcoming-invoices-controls-section">
            {/* <Button className="upcoming-invoices-collect-btn" onClick={() => navigate("/collectpayment")}>Collect Fee</Button>
            <Button className="upcoming-invoices-select-btn" onClick={() => navigate("/SelectStudent")}>Select Students</Button>
            <Button className="upcoming-invoices-special-btn" onClick={() => navigate("/SpecialFees")}>Special Fees</Button> */}

            {/* <div className="upcoming-invoices-toggle-section">
              <span className="upcoming-invoices-toggle-label">Generate Invoice:</span>
              <div className="upcoming-invoices-switch-wrapper">
                <Form.Check
                  type="switch"
                  id="upcoming-invoices-switch"
                  checked={generateInvoice}
                  onChange={handleGenerateInvoiceToggle}
                />
                <span className={`upcoming-invoices-switch-status ${generateInvoice ? 'upcoming-invoices-status-yes' : 'upcoming-invoices-status-no'}`}>
                  {generateInvoice ? 'YES' : 'NO'}
                </span>
              </div>
            </div> */}
          </div>
        </div>

        {/* Filter Section */}
        <div className="upcoming-invoices-filter-section">
          <div className="upcoming-invoices-filter-controls">
            <Form.Select
              className="upcoming-invoices-select-student"
              value={filters.student}
              onChange={(e) =>
                setFilters({ ...filters, student: e.target.value })
              }
            >
              <option value="">Select Student</option>
              {/* You could populate this dynamically from studentModel */}
            </Form.Select>
            <Form.Select
              className="upcoming-invoices-select-year"
              value={filters.academicYear}
              onChange={(e) =>
                setFilters({ ...filters, academicYear: e.target.value })
              }
            >
              <option value="">Select Academic Year</option>
              <option value="2020-2021">2020-2021</option>
              <option value="2023-2024">2023-2024</option>
            </Form.Select>
            <Button
              onClick={handleClear}
              className="upcoming-invoices-clear-button"
            >
              Clear
            </Button>
          </div>
        </div>

        <div className="upcoming-invoices-table-header-row">
          <div className="upcoming-invoices-grid-layout">
            <div className="upcoming-invoices-header-cell">#</div>
            <div className="upcoming-invoices-header-cell">Invoice ID</div>
            <div className="upcoming-invoices-header-cell">Student</div>
            <div className="upcoming-invoices-header-cell">Academic Year</div>
            <div className="upcoming-invoices-header-cell">Demand Date</div>
            <div className="upcoming-invoices-header-cell">Due Date</div>
            <div className="upcoming-invoices-header-cell">Amount Total</div>
            <div className="upcoming-invoices-header-cell">Amount Paid</div>
            <div className="upcoming-invoices-header-cell">Balance</div>
          </div>
        </div>
        {isLoading ? (
          <div className="text-center my-3">
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : (
          <>
            <div className="upcoming-invoices-data-rows-wrapper">
              {invoices.length > 0 ? (
                invoices.map((item, index) => (
                  <div key={item.id} className="upcoming-invoices-row-card">
                    <div className="upcoming-invoices-grid-layout">
                      <div className="upcoming-invoices-data-cell">
                        {index + 1}
                      </div>
                      <div className="upcoming-invoices-data-cell">
                        {item.invoiceId}
                      </div>
                      <div className="upcoming-invoices-data-cell">
                        {item.student}
                      </div>
                      <div className="upcoming-invoices-data-cell">
                        {item.academicYear}
                      </div>
                      <div className="upcoming-invoices-data-cell">
                        {item.demandDate}
                      </div>
                      <div className="upcoming-invoices-data-cell">
                        {item.dueDate}
                      </div>
                      <div className="upcoming-invoices-data-cell">
                        ${item.amountTotal.toLocaleString()}
                      </div>
                      <div className="upcoming-invoices-data-cell">
                        ${item.amountPaid.toLocaleString()}
                      </div>
                      <div className="upcoming-invoices-data-cell">
                        ${item.balance.toLocaleString()}
                      </div>
                      {/* <div className="upcoming-invoices-data-cell upcoming-invoices-action-cell">
                      <button className="upcoming-invoices-action-icon" onClick={() => navigate(`/view-bill/${item.id}`)}><FaEye /></button>
                      <button className="upcoming-invoices-action-icon" onClick={() => navigate(`/edit-bill/${item.id}`)}><FaEdit /></button>
                      <button className="upcoming-invoices-action-icon text-danger"><FaTrashAlt /></button>
                    </div> */}
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center p-5">No invoices found.</div>
              )}
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default ViewInvoice;
